
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NudgeService {
    env = environment;
    constructor(private http: HttpClient) { }

    GetNudgeDetails() {
        return this.http.get(this.env.webApiUrl + 'api/Nudge/GetDashboardNudgeStatus');
    }
    InsertOrUpdateNudgeDetails(params: any) {

        return this.http.post(this.env.webApiUrl + 'api/Nudge/InsertOrUpdateDashboardNudge', params);

    }

    getNudgeStatus(data: any) {
        return this.http.post(this.env.webApiUrl + 'api/Nudge/GetNudgeStatus', data);
    }
    upsertNudgeDate(data: any) {
    sessionStorage.setItem("IsOfferNudged", "true");    
    return this.http.post(this.env.webApiUrl + 'api/Nudge/UpsertNudgeDate', data);
    }

}
